var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { gql } from '@apollo/client';
import { DateTime } from 'luxon';
import { formatDuration, getDurationStr, getTimeIntervalStr } from '@amzn/atoz-shiftapp-utilities';
import { AcceptVtoSuccess } from './index';
import { useTranslation } from 'react-i18next';
import { useAcceptVtoContext } from '../../../context';
export var useAcceptVtoSuccessFeature = function (scheduleShift, acceptedVto) {
    var t = useTranslation().t;
    if (!acceptedVto) {
        return { bannerText: null, vtoDurationStr: null, vtoIntervalStr: null };
    }
    var isFullShiftVTO = function () {
        return shiftStart.equals(vtoStart) && shiftEnd.equals(vtoEnd);
    };
    var getNewShiftStartAndEndTimes = function () {
        if (shiftStart.equals(vtoStart) && vtoEnd < shiftEnd) {
            return {
                newShiftStart: vtoEnd,
                newShiftEnd: shiftEnd
            };
        }
        if (shiftStart < vtoStart && shiftEnd.equals(vtoEnd)) {
            return {
                newShiftStart: shiftStart,
                newShiftEnd: vtoStart
            };
        }
        return {
            newShiftStart: null,
            newShiftEnd: null
        };
    };
    var shiftStart = DateTime.fromISO(scheduleShift.shift.timeRange.start);
    var shiftEnd = DateTime.fromISO(scheduleShift.shift.timeRange.end);
    var vtoStart = DateTime.fromISO(acceptedVto.shift.timeRange.start);
    var vtoEnd = DateTime.fromISO(acceptedVto.shift.timeRange.end);
    var vtoDurationStr = getDurationStr(acceptedVto.shift.duration);
    var vtoIntervalStr = getTimeIntervalStr(vtoStart, vtoEnd);
    if (isFullShiftVTO()) {
        return {
            vtoDurationStr: vtoDurationStr,
            vtoIntervalStr: vtoIntervalStr,
            bannerText: t('shift_management_features_VtoAcceptedConfirmationModal_fullShift')
        };
    }
    var _a = getNewShiftStartAndEndTimes(), newShiftStart = _a.newShiftStart, newShiftEnd = _a.newShiftEnd;
    if (!newShiftStart || !newShiftEnd) {
        return {
            vtoDurationStr: vtoDurationStr,
            vtoIntervalStr: vtoIntervalStr,
            bannerText: null
        };
    }
    var newShiftDuration = newShiftEnd.diff(newShiftStart, [
        'hours',
        'minutes',
        'seconds'
    ]);
    var newShiftDurationStr = formatDuration(newShiftDuration);
    var newShiftIntervalStr = getTimeIntervalStr(newShiftStart, newShiftEnd);
    var bannerText = t('shift_management_features_VtoAcceptedConfirmationModal_stillScheduledToWork', {
        intervalStr: newShiftIntervalStr,
        durationStr: newShiftDurationStr
    });
    return {
        vtoDurationStr: vtoDurationStr,
        vtoIntervalStr: vtoIntervalStr,
        bannerText: bannerText
    };
};
export var AcceptVtoSuccessFeature = function (_a) {
    var scheduleShift = _a.scheduleShift, close = _a.close;
    var selectedVto = useAcceptVtoContext()[0].selectedVto;
    var acceptVtoSuccessProps = useAcceptVtoSuccessFeature(scheduleShift, selectedVto);
    return React.createElement(AcceptVtoSuccess, __assign({}, acceptVtoSuccessProps, { close: close }));
};
AcceptVtoSuccessFeature.fragments = {
    shiftOpportunity: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment AcceptVtoSuccess_ShiftOpportunity on ShiftOpportunity {\n            shift {\n                id\n                timeRange {\n                    start\n                    end\n                }\n                duration {\n                    value\n                }\n            }\n        }\n    "], ["\n        fragment AcceptVtoSuccess_ShiftOpportunity on ShiftOpportunity {\n            shift {\n                id\n                timeRange {\n                    start\n                    end\n                }\n                duration {\n                    value\n                }\n            }\n        }\n    "]))),
    scheduleShift: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment AcceptVtoSuccess_ScheduleShift on ScheduleShift {\n            shift {\n                timeRange {\n                    start\n                    end\n                }\n                duration {\n                    value\n                }\n            }\n        }\n    "], ["\n        fragment AcceptVtoSuccess_ScheduleShift on ScheduleShift {\n            shift {\n                timeRange {\n                    start\n                    end\n                }\n                duration {\n                    value\n                }\n            }\n        }\n    "])))
};
var templateObject_1, templateObject_2;
